module.exports = __webpack_public_path__ + "img/125.9.88a6f9a8.png";